export const FILTERS_BEFORE_SHOW_MORE = 3

export const PAGE_SIZE = 48
